let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fnRpB")).then(() => parcelRequire('FXbTY'));